import React, { Component } from 'react'
import {Form,Segment,Button,Input} from "semantic-ui-react"
import { DropzoneComponent } from 'react-dropzone-component';
const uuidv1 = require('uuid/v1');
class AddNewPVRoom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saved: false,
            uploading: false,
            roomName: undefined,
            roomDescription: undefined,
            roomIssues:undefined,
            roomFlag: false,
            attachments: [],
            showAdd: true,
            rooms: [],
            notSaved: false,
            currentImageCount: 1,
            totalImageCount: 0
        };
    }

    handleSubmit = () => {
        let roomImages = [...this.state.attachments]
        let newRoom = {
        roomName: this.state.roomName,
        roomDescription: this.state.roomDescription,
        roomIssues:this.state.roomIssues||"",
        roomFlag: this.state.roomFlag,
        client_id: uuidv1(), 
        images: roomImages
        }
        this.props.addRoom(newRoom)
      this.setState({ roomName: undefined, roomDescription: undefined, roomIssues:undefined, roomFlag: false, attachments: [], showAdd: false, }, () => {
        this.setState({ showAdd: true })
      });
    }
    render() {
        let dropZone = null;
        const componentConfig = { postUrl: 'no-url' };
        let djsConfig = { autoProcessQueue: false, addRemoveLinks: true, maxFiles: 2000, acceptedFiles: "image/*" };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
            },
            addedfile: (file) => {
                let imageObj = {
                    id: file.upload.uuid,
                    client_id: file.upload.uuid,
                    image: file
                }
                this.state.attachments.push(imageObj);
                this.setState({ fileAdded: true, preLoaded: false });
            },
            removedfile: (file) => {
                this.setState({ attachments: [] });
            },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({ maxNumberOfFilesExceeded: true });
                setTimeout(() => {
                    this.setState({ maxNumberOfFilesExceeded: false })
                }, 10000)
            }
        };

       

        return <Segment className="pv-data-input">
            {this.state.showAdd && <Form >
                <Form.Group >
                    <Form.Field width={5}>
                        <label>Room Name</label>
                        <Input
                            type="text"
                            placeholder="Hallway"
                            ref="roomName"
                            required
                            onChange={(e) => {
                                this.setState({ roomName: e.target.value })
                            }}
                        />
                    </Form.Field>
                    <Form.Field width={5}>
                        <label>Room Description</label>
                        <Input
                            type="text"
                            placeholder="General Room Description"
                            ref="roomDescription"
                            required
                            onChange={(e) => {
                                this.setState({ roomDescription: e.target.value })
                            }}
                        />
                    </Form.Field>
                    <Form.Field width={5}>
                        <label>Room Issues</label>
                        <Input
                            type="text"
                            placeholder="Issues Requiring Attention"
                            ref="roomIssues"
                            optional
                            onChange={(e) => {
                                this.setState({ roomIssues: e.target.value })
                            }}
                        />
                    </Form.Field>

                </Form.Group>

                <DropzoneComponent key={this.props.reportId} config={componentConfig}
                    eventHandlers={eventHandlers}
                    djsConfig={djsConfig} />
                <div style={{ textAlign: "center", paddingTop: "15px" }}>
                    <Button onClick={this.handleSubmit} disabled={!(this.state.roomName && this.state.roomDescription)} primary content="Add New Room" /></div>
            </Form>}
        </Segment>
    }
}

export default AddNewPVRoom


// WEBPACK FOOTER //
// ./src/views/property_visits/add_new_pv_room.js